import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const SITE_ID = process.env.REACT_APP_SITE_ID || 'catchingon';

const api = axios.create({
  baseURL: `${API_URL}/${SITE_ID}`,
  headers: { 'Content-Type': 'application/json' },
});

export const submitContact = (data) => api.post('/contact', data);
export const subscribeEmail = (email) => api.post('/emails', { email });

export const fetchPosts = () => api.get('/posts').then(r => r.data);
export const fetchPost = (slug) => api.get(`/posts/${slug}`).then(r => r.data);

export { API_URL, SITE_ID };
